import DeleteOutlineOutlined from '@mui/icons-material/DeleteOutlineOutlined';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function DeleteOutlineOutlinedIcon(props: FixMe) {
  return <DeleteOutlineOutlined {...props} />;
}

export default DeleteOutlineOutlinedIcon;
